import { PromoBanner } from '@hungryroot/homepage';
import { islandRoot } from '../IslandRoot/IslandRoot';

export const PromoBannerIsland = islandRoot(PromoBanner);
